export const removeCharactersFromTextNodes = (element: any, showMore: boolean) => {
  if (!showMore) return;
  // Check if the element is a text node
  if (!element) return;

  if (element.nodeType === Node.TEXT_NODE) {
    // Remove the specified characters from the text content
    element.textContent = element.textContent.replaceAll(/[*|&\[\]]+/g, "");
    element.textContent = element.textContent.replaceAll(/(https?:\/\/\S+)/g, "");
  } else {
    // Traverse the child nodes of the element recursively
    const children = element.childNodes;

    for (let i = 0; i < children.length; i++) {
      removeCharactersFromTextNodes(children[i], showMore);
    }
  }
};
